// src/pages/NewsPage.js
import React from 'react';
import { Box, Typography, Link as MuiLink, CardMedia } from '@mui/material';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import HeroBanner from '../components/HeroBanner';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import ReactMarkdown from 'react-markdown';
import { newsItems } from '../data/SiteData';

const NewsPage = () => {
  const { newsId } = useParams();

  // Find the news item based on the ID in the URL
  const news = newsItems.find((item) => item.newsId === newsId);
  if (!news) return <Typography>News item not found.</Typography>;

  // Breadcrumb items
  const breadcrumbItems = [
    { title: 'Home', path: '/' },
    { title: 'News & Events', path: '/news-events' },
    { title: 'News', path: '/news-events/news' },
    {
      title:
        news.title.length > 30
          ? news.title.substring(0, 30) + '...'
          : news.title,
      path: news.link,
    },
  ];

  // Format date (same as before)
  const formattedDate = news.date || '';

  return (
    <>
      <Navbar />
      <HeroBanner
        heroTitle="News"
        heroDescription="Catch up on all the latest news."
        imageUrl="/images/digiTwins.png"
        height="165px"
      />
      <Breadcrumb items={breadcrumbItems} />

      {/* Main content */}
      <Box sx={{ padding: '32px', maxWidth: '1300px', margin: '0 auto' }}>
        {/* First section */}
        <Box sx={{ display: 'flex', gap: 4, mb: 4, flexWrap: 'wrap' }}>
          {news.image && (
            <CardMedia
              component="img"
              src={news.image}
              alt={news.title}
              sx={{ width: 160, flexShrink: 0, borderRadius: '8px' }}
            />
          )}

          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 600,
                fontSize: '24px',
                color: '#142434',
                mb: 1,
              }}
            >
              {news.title}
            </Typography>

            <Typography
              sx={{
                fontFamily: 'PT Sans, sans-serif',
                fontSize: '14px',
                color: '#142434',
                mb: 1,
              }}
            >
              {formattedDate}
            </Typography>

            <Typography
              sx={{
                fontFamily: 'PT Sans, sans-serif',
                fontSize: '14px',
                color: '#142434',
                mb: 1,
                textTransform: 'uppercase',
              }}
            >
              {news.type}
            </Typography>

            {news.extLink && (
              <MuiLink
                href={news.extLink}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  fontFamily: 'PT Sans, sans-serif',
                  fontSize: 14,
                  wordBreak: 'break-all',
                }}
              >
                {news.extLink}
              </MuiLink>
            )}
          </Box>
        </Box>

        {/* Second section: mainContent */}
{news.mainContent && (
  <Box
    sx={{
      mt: 4,
      fontFamily: 'PT Sans, sans-serif',
      fontSize: '16px',
      lineHeight: 1.6,
      color: '#142434',
      '& h1, & h2, & h3, & h4, & h5, & h6': {
        fontFamily: 'Poppins, sans-serif',
      },
      '& a': {
        color: '#489596',
        textDecoration: 'underline',
      },
    }}
  >
    <ReactMarkdown>{news.mainContent}</ReactMarkdown>
  </Box>
)}

      </Box>

      <Footer />
    </>
  );
};

export default NewsPage;
